<template>
  <div class="head_container" v-if="user!==''">
    <div class="left">
      <div class="search_box">
        <img src="@/assets/img/center/search.png" @click="getSearch">
        <input
          v-model="search"
          type="text"
          placeholder="搜索接口"
          maxlength="16"
          @keyup.enter="getSearch('/search','_blank')">
      </div>
      <span @click="toLink('/','_blank')" class="to_index">数据商城</span>
      <span @click="toLink('/help/helpCenter?type=2','_blank')" class="to_index">使用帮助</span>
    </div>
    <div class="right">
      <!--      v-if="JSON.stringify(user)!=='{}'"-->
      <div class="api_box">
        <span class="key" @mousemove="showTip(1)" @mouseleave="showTip(0)">API KEY：{{ showKey }}</span>
        <span
          class="copy"
          id="btns"
          @click="copeKey">复制</span>
      </div>
      <div @mouseenter="seeNoticeList" @mouseleave="closeNoticeList">
        <el-badge is-dot :hidden="readNum<1">
          <div class="small_bell_box">
            <img src="@/assets/img/center/bell.png" style="width: 20px;height: 20px;"/>
          </div>
        </el-badge>
        <div class="position_notice" v-if="openNoticeList" ref="treeWrap">
          <div class="notice_top_box">
            <div class="notice_top_inside">
              <div class="notice_top_div">
                通知
              </div>
            </div>
          </div>
          <div class="notice_inside_box">
            <div v-for="(item,index) in noticeList" :key="index" class="one_list_notice"
                 @click="toNoticeDetail(item)">
              <div class="notice_title_date">
                <img src="@/assets/img/logoIcon.png" style="width: 20px;height: 20px">
                <span :class="item&&item.readed===0?'notice_title_style_red':'notice_title_style'">{{
                    item.title
                  }}</span>
                <span style="display: block;color: grey;font-size: 14px">{{
                    item.publishTime.split(' ')[0]
                  }}</span>
              </div>
              <div class="notice_content_style" v-html="item.content"></div>
            </div>
          </div>
          <div>
            <el-divider content-position="center"><span style="color: rgb(220,223,230)">仅显示6个月内通知</span>
            </el-divider>
          </div>
        </div>
      </div>
      <div class="name">
        <el-popover
          placement="top-start"
          width="215"
          trigger="hover"
        >
          <div class="user_name" slot="reference">
            <span class="account">{{ user.name }}</span>
            <i class="go"/>
          </div>
          <div class="leave">
            <div class="info_line">
              <a to="/editInfo" class="user_info">
                <img src="@/assets/img/center/avatar.png" v-if="user.icoPath === ''">
                <img v-else :src="user.icoPath">
                <span>{{ user.name }}</span>
              </a>
              <span class="leave_btn" @click="dropOut">退出</span>
            </div>
            <div class="info_line">
              <router-link to="/myAccount/personAccount">
                余额：<i>{{ balance !== 0 ? parseFloat(balance).toFixed(2) : '0.00' }}</i></router-link>
              <router-link to="/myAccount/recharge">充值</router-link>
            </div>
            <p class="more_tip">
              更多设置请转移左侧导航
            </p>
          </div>
        </el-popover>
      </div>
    </div>
    <div class="key_tip" v-if="show">
      <p>您的APIKEY:</p>
      <p>{{ apikey }}</p>
    </div>
    <div style="clear:both;"/>
  </div>
</template>

<script>
import common from "../../utils/common";
import {loginOut} from '@/api/login';
import linkPath from '../../config/linkpath';
import {newGetNotice, readNotice} from '@/api/user';
import {getAccountInfo} from "@/api/center";


export default {
  props: {
    info: Object
  },
  data() {
    return {
      search: '',
      user: 1,
      isPop: false,
      showKey: '',
      show: false,
      isPop2: false,
      balance: 0,
      apikey: '',
      noticeList: [],
      readNum: 0,
      openNoticeList: false,
      bellEnter: false
    }
  },
  mounted() {
    if (!this.$cookies.get('token')) {
      this.$confirm('登录状态已过期，请重新登陆', '', {showCancelButton: false}).then(() => {
        this.$router.push('/login')
      })
    } else {
      let data = window.localStorage.getItem('data');
      if (data) {
        this.user = JSON.parse(data);
        this.updateUserInfo();
      }
      this.getRecentNotice();
      this.testToken();
    }
    let that = this;
    document.addEventListener('mouseup', (e) => {
      let tree = this.$refs.treeWrap;
      if (tree) {
        if (!tree.contains(e.target)) {
          that.openNoticeList = false;
        }
      }
    })
  },
  methods: {
    getRecentNotice() {
      this.readNum = 0;
      newGetNotice().then(res => {
        this.noticeList = res.data;
        this.noticeList.forEach(item => {
          if ((item.readed !== '' && item.readed !== undefined && item.readed !== null) && item.readed === 0) {
            this.readNum += 1;
          }
        })
      })
    },
    seeNoticeList() {
      this.openNoticeList = true;
      this.bellEnter = true;
    },
    closeNoticeList() {
      this.openNoticeList = false;
    },
    toNoticeDetail(row) {
      this.$alert(row.content, row.title, {dangerouslyUseHTMLString: true, customClass: 'custom_alert'})
      // window.localStorage.setItem('nowNotice', JSON.stringify(row));
      // this.$router.push('/notice');
      if(row.readed===0){
        this.readNotice(row.id);
      }
      this.openNoticeList = false;
    },
    readNotice(id) {
      readNotice({id: id}).then(res => {
        if (res.success) {
          this.getRecentNotice();
        }
      })
    },
    toLink(url, target) {
      window.open(linkPath + url, target)
      // console.log(linkPath + url)
    },
    // 搜索跳转新页
    getSearch(url, target) {
      let that = this;
      window.open(linkPath + `${url}?val=` + that.search, target)
      // let routeData = that.$router.resolve({
      //   path: '/search',
      //   query: {
      //     val: that.search
      //   },
      //   target: '_blank'
      // });
      // window.open(routeData.href, '_blank');
    },
    showPop(isOpen) {
      // if (isOpen === 1) {
      //   this.isPop = 1;
      //   this.isPop2 = 1;
      // } else {
      //   this.isPop = 0;
      // }
    },
    showPop2(isOpen) {
      // if (isOpen === 2) {
      //   this.isPop2 = 1;
      // }
      // if (isOpen === 3) {
      //   this.isPop2 = 0;
      // }
    },
    dropOut() {
      let that = this;
      this.$confirm('确认要退出登录吗?', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        loginOut().then(res => {
          if (res.success) {
            that.$router.push('/');
          }
        })
      }).catch(function () {

      });
    },
    showTip(e) {
      // this.show = e === 1;
    },
    updateUserInfo() {
      getAccountInfo().then(res => {
        if (res.success) {
          this.userInfo = res.data;
          // let total = this.userInfo.totalGold ? this.userInfo.totalGold : 0;
          // let largess = this.userInfo.largessGold ? this.userInfo.largessGold : 0;
          // let consump = this.userInfo.consumptionGold ? this.userInfo.consumptionGold : 0;
          this.balance = this.userInfo.GoldMoney ? this.userInfo.GoldMoney : 0;
        }
      })
    },
    hideKey(apikey) {
      if (apikey) {
        let key = apikey;
        this.showKey = key.substr(0, 3) + '****' + key.substr(key.length - 3, 3);
      }
    },
    // 复制apikey
    copeKey() {
      let copy = this.apikey;
      common.copy(copy, '#btns');
    },

    testToken() {
      const data = localStorage.getItem('data') ? JSON.parse(localStorage.getItem('data')) : {};
      this.apikey = data.apiKey;
      this.hideKey(this.apikey);
    }
  },
  watch: {
    // 监听用户信息变化，实时修改账户余额
    info(newV, oldV) { // watch监听props里值的变化，然后执行操作
      // if (newV) {
      //   this.user = newV;
      //   this.testToken();
      //   this.setBalance(newV);
      // }
    }
  }
}
</script>

<style scoped>
i {
  font-style: normal;
}

.head_container {
  width: 84%;
  min-width: 975px;
  display: flex;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  margin-left: 310px;
  border-bottom: 1px solid rgba(236, 240, 244, 1);
  z-index: 1;
}

.to_index {
  display: inline-block;
  width: 65px;
  text-decoration: #3a8ee6;
  border-bottom: 1px solid #c1c1c1;
  color: #c1c1c1;
  cursor: pointer;
  margin-left: 20px;
  padding-bottom: 2px;
}

.to_index:hover {
  color: #49BAFF;
  border-bottom: 1px solid #49BAFF;
}

.left {
  display: flex;

  flex: 1;
  align-items: center;
}

.logo {
  padding: 7px 0 6px 0;
  margin-left: 63px;
}

.logo img {
  width: 178px;
  height: 67px;
}

.search_box {
  position: relative;
  margin: 17px 0 19px 22px;
  height: 44px;
}

.search_box input {
  display: flex;
  padding: 0 33px 0 40px;
  width: 254px;
  height: 100%;
  border-radius: 6px;
  border: 1px solid rgba(230, 230, 230, 1);
  font-size: 16px;
  outline: none;
}

.search_box img {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 17px;
  cursor: pointer;
}

.right {
  padding: 0 73px 0 0;
  display: flex;
  justify-self: flex-end;
  align-items: center;
  font-size: 16px;
  color: rgba(172, 173, 173, 1);
  line-height: 22px;
}

.api_box {
  width: 290px;
  font-size: 16px;
}

.api_box .copy {
  margin-left: 20px;
  color: #49BAFF;
  cursor: pointer;
}

.name {
  display: flex;
  margin-left: 95px;
  /*position: relative;*/
}

.name .user_name {
  display: flex;
  cursor: pointer;
  padding: 0 30px;
}

.name .go {
  display: block;
  margin: 7px 0 0 8px;
  width: 9px;
  height: 7px;
  background: url("../../assets/img/center/file_logo.png") no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

.small_bell_box {
  width: 30px;
  height: 30px;
  background-color: rgb(230, 247, 255);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.leave {
  /*position: absolute;*/
  /*right: 0;*/
  /*top: 31px;*/
  /*display: none;*/
  /*border: 1px solid rgba(236, 240, 244, 1);*/
  border-radius: 4px;
  width: 190px;
  overflow: hidden;
  /*height: 35px;*/
  /*line-height: 35px;*/
  text-align: center;
  font-size: 14px;
  background: #fff;
  z-index: 10;
  /*padding-top: 10px;*/
  /*box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.06);*/
}

.name:hover .leave {
  /*display: inline-block;*/
}

.info_line {
  display: flex;
  line-height: 30px;
  text-align: center;
  padding: 0 10px;
  margin-bottom: 5px;
}

.info_line .user_info {
  display: flex;
  flex: 1;
}

.info_line .user_info img {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid #ececec;
  margin-right: 10px;
}

.info_line a {
  text-decoration: none;
  color: #333333;
}

.info_line a:nth-child(1) {
  flex: 1;
  text-align: left;
}

.info_line a:nth-child(2) {
  color: #4AD3B7;
  cursor: pointer;
  text-decoration: none;
}

.info_line a i {
  color: orange;
}

.leave_btn {
  cursor: pointer;
}

.leave_btn:hover {
  color: #4AD3B7;
}

.more_tip {
  display: block;
  width: 100%;
  line-height: 30px;
  background: #cbcbcb;
  color: #fff;
}

.key {
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

.key_tip {
  position: absolute;
  right: 243px;
  top: 70px;
  padding: 5px 10px;
  border-radius: 5px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.25);
  background: #fff;
  z-index: 10;
  color: #333333;
  width: 370px;
  overflow: hidden;
}

.key_tip p {
  line-height: 22px;
  font-size: 13px;
  word-break: break-all;
}

.user_tip {

}

@media screen and (max-width: 1560px) {
  .head_container {
    margin-left: 289px;
  }

  .logo img {
    width: 140px;
    height: 50px;
  }

  .search_box {
    margin: 14px 0 14px 15px;
    height: 36px;
  }

  .right {
    padding-top: 22px;
  }

  /*.leave {*/
  /*top: 60px;*/
  /*}*/
  .key_tip {
    top: 60px;
    right: 290px;
  }

  .key_tip p {
    line-height: 20px;
    font-size: 12px !important;
  }
}

@media screen and (max-width: 1350px) {
  .head_container {
    margin-left: 225px;
  }

  .logo img {
    width: 112px;
    height: 42px;
  }

  .search_box {
    margin: 12px 0 12px 15px;
    height: 34px;
  }

  .search_box input {
    font-size: 14px;
  }

  .right {
    padding-top: 18px;
  }

  .api_box {
    font-size: 16px;
  }

  .name {
    margin-left: 64px;
  }

  /*.leave {*/
  /*top: 50px;*/
  /*}*/
  .key_tip {
    top: 55px;
  }

  .key_tip p {
    font-size: 12px !important;
  }

  @media screen and (max-width: 1349px) {
    .head_container {
      position: absolute;
    }
  }
}

/*公告样式*/
.position_notice {
  position: absolute;
  width: 400px;
  height: 600px;
  background-color: white;
  right: 3%;
  top: 69%;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.notice_top_box {
  width: 100%;
  height: 50px;
  border-radius: 10px 10px 0 0;
}

.notice_top_inside {
  width: 98%;
  height: 50px;
  margin: 0 auto;
  border-bottom: 1px solid rgb(121, 121, 121);
}

.notice_top_div {
  width: 100px;
  height: 50px;
  border-bottom: 3px solid rgb(20, 122, 252);
  color: rgb(20, 122, 252);
  line-height: 50px;
}

.notice_inside_box {
  width: 98%;
  height: 500px;
  margin: 0 auto;
  overflow-y: auto;
  padding: 10px 0;
}

.one_list_notice {
  width: 100%;
  height: 60px;
  padding: 3px;
}

.notice_title_date {
  display: flex;
  justify-content: space-between;
  padding: 0 5px;
}

.notice_title_style {
  display: block;
  width: 70%;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.notice_title_style_red {
  display: block;
  width: 70%;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: red;
}

.notice_content_style {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 5px;
  width: 80%;
  height: 20px;
  text-align: left;
  margin-left: 40px;
}

.one_list_notice:hover {
  width: 100%;
  height: 60px;
  padding: 3px;
  background-color: rgb(250, 250, 250);
}
</style>
<style>
.custom_alert {
  width: 40% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/head/index.vue